<div
  style="height: 20px"
  fxLayoutAlign="start center"
  fxLayout="row"
  fxLayoutGap="{{ FlexLayoutType.Gap.XSmall }}"
>
  <div class="progress-cont">
    <div class="progress-bar" [style.width]="progress + '%'"></div>
  </div>
  <div class="progress-percent">{{ progress }}%</div>
</div>
